import React from 'react';
import Address from './Address'
import { connect } from 'react-redux';
import { profile,  ui as profileUi } from '../../../modules/customer';
import { config, customer } from '../../../modules';
import LoadingPanel from '../../components/LoadingPanel';
import ActionButton from '../../components/ActionButton';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';
import Box from '../profilePage/components/Box';
import { BoxesRow } from '../profilePage/components';

const ottStatusList = [
    { status: 'Red', label: 'Not connected', textToDisplay: 'Denne kunden har ikke koblet utstyr til internett - hvis kunden har Smart boks - informer kunden om hvilke tjenester som finnes der - fokuser på arkivet som er gratis' },
    { status: 'Orange', label: 'Connected, but not active in 30 days', textToDisplay: 'Denne kunden har vært koblet til internett tidligere men er ikke koblet de siste 30 dagene - spør kunde om hvorfor han/hun har koblet fra Smart boksen. Logg gjerne contact om hvorfor.' },
    { status: 'Green', label: 'Connected and active', textToDisplay: 'Denne kunden har koblet Smart boksen til internett - spør om hun/han om de bruker tjenestene ofte' }
];

const Details = ({ defaultAddress, OTTStatus, customerId, iccUrl, profileData, isLoading }) => {

    const { id, firstName, lastName, mobilePhone, birthDate, email, customerClass, type, externalReference } = profileData;
    const emailClass = classnames('customer-small', { 'error': !profileData.email.trim() });
    const customerStatusClass = classnames('hide', {
        'status-circle circle-big': true,
        'status-unknown': true,
        'status-not-ok': false,
        'status-warn': false,
        'status-ok': false
    });
    const accountStatusClass = classnames('hide', {
        'status-circle circle-big': true,
        'status-unknown': true,
        'status-not-ok': false,
        'status-warn': false,
        'status-ok': false
    });
    const OTTStatusClass = classnames({
        'status-circle circle-huge': true,
        'status-not-ok': OTTStatus.value === 'Red',
        'status-warn': OTTStatus.value === 'Orange',
        'status-ok': OTTStatus.value === 'Green'
    });
    const iccCustomerProfile = `${iccUrl}/PSM/CSR/CSRHandler.aspx?customerID=${customerId}`;
    const gembaCustomerProfile = `/#/customer/${customerId}`;
    const ottText = (ottStatusList.find(item => item.status === OTTStatus.value) || { label: '' }).label;

    const name = isLoading? "Laster .." : `${customerId} - ${firstName} ${lastName}`;

    const buttons = [
        <ActionButton icon="user" to={'/#/customer/'+customerId} title="Oversikt" key="abOversikt"/>,
        <ActionButton icon="user" to={'/#/customer/'+customerId +'/manage'} title="Manage" key="abManage"/>
    ];

    return (
        <BoxesRow>
            <Box className="boxWrapper" label={name} buttons={buttons} >
                <div className="container-fluid">
                    {isLoading && <LoadingPanel />}
                    {!isLoading && <div>
                        <div className="row">
                            <div className="col-md-3"> 
                                <b>Fødselsdato:</b> {birthDate} <br />
                                <b>Klasse:</b> {customerClass} <br />
                                <b>Type:</b> {type} <br />
                                <b>Partner kundenummer:</b> {externalReference}
                            </div>
                            <div className="col-md-4">
                                {defaultAddress && <Address {...defaultAddress} />}
                                <b>Tlf:</b> {mobilePhone} <br />
                                <b>E-post:</b> {email}
                            </div>
                            <div className="col-md-4">
                                <b>Account status:</b> {profileData.status} <br />
                                <b>Financial account status:</b> {profileData.financialAccountStatus} <br />
                                <b>Dunning level:</b> {profileData.dunningLevel} <br />
                                <b>SmartBoks status:</b> {ottText} <br /> 
                            </div>
                            <div className="col-md-1 text-right">
                                <div className={OTTStatusClass} title={ottText}>
                                    <span className="status-text">SMB</span>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </Box>
        </BoxesRow>
    );
}

const mapStateToProps = createStructuredSelector({
    defaultAddress: profile.selectors.getDefaultAddress,
    OTTStatus: profile.selectors.getOTTStatus,
    customerId: profile.selectors.getCustomerID,
    iccUrl: config.selectors.getIccUrl,
    profileData: profile.selectors.getCustomerDetails,
    isLoading: customer.profile.selectors.isLoading
});

export default connect(mapStateToProps)(Details);
